import { ICommandGroupMap } from 'src/common/interfaces/dtos/ICommandsGroup';
import { IActionButton } from 'src/common/interfaces/dtos/ICashOfficeActionButton';

export interface ITabs {
  [groupName: string]: ITabGroup;
}

export interface ITabGroup {
  id: string;
  tabs: ITab[];
}

export interface ITab {
  tabId: string;
  displayName?: string;
  description?: string;
  tabOrder?: number;
  isActive?: boolean;
  isReserved?: boolean;
  commands?: ICommandGroupMap;

  //pos migration members...these will slowly be migrated/removed/incoroprated into the above CCM model
  component?: React.ComponentType;
  buttonList?: IButtonList;
  disabledWhen?: typeof disabledWhenActive;
}

export interface IButtonList {
  title: string;
  testId: string;
  // actions have to be callable because they rely on a redux value that might not be available on init
  actions: () => IActionButton[];
}

export const disabledWhenActive = (val: boolean): boolean => val;
